module.exports = __webpack_public_path__ + "img/idx_tit4.e3589000.png";